'use strict';

var EventEmitter = require('events').EventEmitter,
    assign = require('object-assign'),
    {round} = require('lodash/math'),
    get = require('lodash/object').get,
    {find, filter} = require('lodash/collection'),
    ContentUtils = require('utils/ContentUtils'),
    SchedulerAppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    getBoundingClientRect =require('bounding-client-rect'),
    DATE_FORMAT = require('constants/AppConstants').DATE_FORMAT,
    ActionTypes = require('constants/AppConstants').ActionTypes,
    moment = require('moment'),
    DateUtils = require('utils/DateUtils'),
    ChronologycServiceCache = require('services/ChronologycServiceCache'),
    ChronologycServiceImpl = require('services/ChronologycServiceImpl'),
    PositionUtil = require('utils/PositionUtils'),
    CHANGE_EVENT = 'emit',
    currentRangeOfDate = [],
    currentFrom,
    currentTo,
    ChronologycStore;

ChronologycStore = assign({}, EventEmitter.prototype, {

    _isNoteSaving: false,
    _isWritingNote: false,

        setIsNoteSavingTrue() {
        this._isNoteSaving = true;
    },

    setIsNoteSavingFalse() {
        this._isNoteSaving = false;
    },

    isSavingNote() {
        return this._isNoteSaving;
    },

    setIsWritingTrue() {
        this._isWritingNote = true;
    },

    setIsWritingFalse() {
        this._isWritingNote = false;
    },

    isWritingNote() {
        return this._isWritingNote;
    },

    setCurrentRange: function (from, to) {
        currentFrom = from;
        currentTo = to;
        currentRangeOfDate = this.getRangeOfDate(from, to);
    },

    fetchBrewingNotes: function (success) {
        ChronologycServiceImpl.fetchBrewingNotes(function () {
            ChronologycServiceCache.fillBrewingNoteCache(JSON.parse(this.responseText));
            if (success) {
                success();
            }
        });
    },

    fetchPackagingNotes: function (success) {
        ChronologycServiceImpl.fetchPackagingNotes(function () {
            ChronologycServiceCache.fillPackagingNoteCache(JSON.parse(this.responseText));
            if (success) {
                success();
            }
        });
    },

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    removeChangeListener: function (call) {
        this.removeListener(CHANGE_EVENT, call);
    },

    addChangeListener: function (call) {
        this.on(CHANGE_EVENT, call);
    },

    getRangeOfDate: function (from, to, typeBar) {
        let days = [],
            formatDate = null,
            i = 0,
            messages,
            messageDay,
            dayCompare;

        if (moment(from, DATE_FORMAT).isAfter(moment(to, DATE_FORMAT))) {
            //console.log('The date ' + from + ' cant be after to' + to);
            return days;
        }

        messages = typeBar === 'packaging-bar' ? ChronologycServiceCache.getPackagingNotes() : ChronologycServiceCache.getBrewingNotes();

        if (!messages) {
            messages = [];
        }

        for (i = 0; moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT) !== to; i++) {
            dayCompare = moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT);
            messageDay = find(messages, (msg) => get(msg, 'date') === dayCompare);
            formatDate = getFormatDate(from, i, messageDay);
            days.push(formatDate);
        }
        // add last the last day
        dayCompare = moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT);
        messageDay = find(messages, (msg) => get(msg, 'date') === dayCompare);
        formatDate = getFormatDate(from, i, messageDay);

        days.push(formatDate);
        return days;
    },

    getCurrentRangeOfDate: function () {
        return currentRangeOfDate;
    },

    getCurrentFrom: function () {
        return currentFrom;
    },

    getCurrentTo: function () {
        return currentTo;
    },

    getFirstDate: function (newPosition) {
        if (!newPosition) {
            return;
        }
        const filterDate = filter(currentRangeOfDate, day => {
            return day.index === newPosition.y;
        });

        if (filterDate && filterDate.length > 0) {
            return filterDate[0];
        } else {
            const fromDate = this.getCurrentFrom();
            return {date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), newPosition.y)};
        }
    },

    getLastDate: function (newPosition) {
        if (!newPosition) {
            return;
        }
        const filterDate = filter(currentRangeOfDate, day => {
            return day.index === (newPosition.y + (newPosition.h - 1));
        });

        if (filterDate && filterDate.length > 0) {
            return filterDate[0];
        } else {
            const fromDate = this.getCurrentFrom();
            return {date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), newPosition.y)};
        }
    },

    /**
     * Retrieve the Date of Event.clientY position.
     * @param {Number} clientY
     * @return {Date}
     */
    getDateFromClientY(clientY) {
        // the number 5, is because 0, have problem in Chrome Win.
        const elY = PositionUtil.elementFromPoint(5, clientY);
        let chronologycRowWanted,
            dateRow;

        if (elY && elY.hasAttribute && elY.hasAttribute('data-date')) {
            dateRow = DateUtils.toDate(elY.getAttribute('data-date'));
        } else {
            chronologycRowWanted = ContentUtils.getComponentByAttribute(elY, 'data-date');
            if (chronologycRowWanted && chronologycRowWanted.getAttribute) {
                dateRow = chronologycRowWanted.getAttribute('data-date');
                dateRow = DateUtils.toDate(dateRow);
            }
        }

        return dateRow;
    },

    _getChronologycElByClientY(elY) {
        const chronologycBarEl = ContentUtils.getComponentByClassName(elY, 'chronologyc-bar');
        for (const chronologycRow of chronologycBarEl.childNodes) {
            if (round(getBoundingClientRect(chronologycRow).top) === round(getBoundingClientRect(elY).top)) {
                return chronologycRow;
            }
        }
    },

    getDateFromPositionY: function (positionY) {
        if (positionY === undefined || positionY === null) {
            return;
        }
        var dateTarget;

        const result = filter(currentRangeOfDate, date => {
            return date.index === positionY;
        });

        if (result && result.length > 0) {
            dateTarget = result[0];
        } else {
            const fromDate = this.getCurrentFrom();
            dateTarget = {date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), positionY)};
        }

        return dateTarget;
    },

    getYFromDate: function (dateTarget) {
        return DateUtils.getDaysBetween(this.getCurrentFrom(), dateTarget);
    },

    isPositionOutOfRange(position) {
        if (!position) {
            return true;
        }

        const from = this.getDateFromPositionY(position.y).date;
        const to = this.getDateFromPositionY((position.h + position.y - 1)).date;

        if (DateUtils.isBefore(from, this.getCurrentFrom()) || DateUtils.isAfter(to, this.getCurrentTo())) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * Retrieve the H between to dates.
     * @argument {String} firstDate is the origin date
     * @argument {String} lastDate is the last date
     * @return {Number}
     */
    getHFromDate: function (firstDate, lastDate) {
        return DateUtils.getDaysBetween(firstDate, lastDate) + 1; // The plus `one` is because ReactGridLayout, the minimal box Height is 1. Represent minimal height row position.
    }

});

function getFormatDate(date, dateNumber, messageDay) {
    return {
        dateName: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('dd').substring(0, 1), // The format of chronologyc bar days name
        dateNumber: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('D'),
        dateNumberAndMonth: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('MM-DD'),
        date: moment(date, DATE_FORMAT).add(dateNumber, 'days').format(DATE_FORMAT),
        time: moment(date, DATE_FORMAT).add(dateNumber, 'days').format() + dateNumber,
        index: dateNumber,
        message: messageDay
    };
}

ChronologycStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {

    switch (action.type) {
        case ActionTypes.OPEN_DAY_NOTES:
            ChronologycStore.emitChange();
            break;

        case ActionTypes.CLOSE_DAY_NOTES:
            ChronologycStore.emitChange();
            break;

        case ActionTypes.NOTE_ADDED:
            ChronologycStore.emitChange();
            ChronologycStore.setIsNoteSavingFalse();
            break;

        case ActionTypes.NOTE_BREWING_OPERATION_NEW:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_BREWING_OPERATION_CHANGE:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_BREWING_OPERATION_DELETE:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_PACKAGING_OPERATION_NEW:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_PACKAGING_OPERATION_CHANGE:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_PACKAGING_OPERATION_DELETE:
            ChronologycStore.setIsNoteSavingTrue();
            break;

        case ActionTypes.NOTE_CHANGED:
            ChronologycStore.setIsNoteSavingFalse();
            ChronologycStore.emitChange();
            break;

        case ActionTypes.NOTE_REMOVED:
            ChronologycStore.setIsNoteSavingFalse();
            ChronologycStore.emitChange();
            break;

        case ActionTypes.BREWING_NOTE_NEED_FETCH:
            ChronologycStore.fetchBrewingNotes(function () {
                ChronologycStore.emitChange();
            });
            break;

        case ActionTypes.PACKAGING_NOTE_NEED_FETCH:
            ChronologycStore.fetchPackagingNotes(function () {
                ChronologycStore.emitChange();
            });
            break;

        default:
    }

});

module.exports = ChronologycStore;



/** WEBPACK FOOTER **
 ** ./src/stores/ChronologycStore.js
 **/